import { render, staticRenderFns } from "./LmBlueprintNewOrEdit.vue?vue&type=template&id=63e8958b&scoped=true&"
import script from "./LmBlueprintNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./LmBlueprintNewOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./LmBlueprintNewOrEdit.vue?vue&type=style&index=0&id=63e8958b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e8958b",
  null
  
)

export default component.exports